<mat-chip-list aria-label="">
    <ng-container *ngFor="let value of list">
      <mat-chip class="mat-chip-small">{{ value }}</mat-chip>
    </ng-container>
</mat-chip-list>
